<template>
  <div class="dock_demo">
    <el-button
      @click="requestPower"
      :class="{'blue-button': sendingData, 'default-button': !sendingData}"
      :loading="sendingData"
      round>
      授权设备
    </el-button>
    <el-button
      @click="outLogin"
      style="float: right"
      round>
      退出登录
    </el-button>
    <!--    <el-button type="primary" @click="dialogTableVisible = true">地段授权</el-button>-->
    <!--  地段授权  -->
    <el-dialog title="地段授权" :visible.sync="dialogTableVisible" width="600px">
      <el-form ref="districtAuthorizeForm" :model="formData" :rules="rules" label-width="80px" >
        <el-form-item label="钥匙" prop="keyId">
          <el-select v-model="formData.keyId" placeholder="请选择活动区域">
            <el-option label="302302" value="302302"></el-option>
            <el-option label="301468" value="301468"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="授权区域" prop="districtId">
          <el-select v-model="formData.districtId" multiple placeholder="请选择授权区域">
            <el-option
              v-for="item in districtList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间" prop="startDate">
          <el-row>
            <el-col :span="11">
              <el-date-picker
                :clearable="false"
                v-model="formData.startDate"
                type="date"
                value-format="yyyy年MM月dd日"
                format="yyyy年MM月dd日"
                placeholder="选择日期">
              </el-date-picker>
            </el-col>
            <el-col :span="2" style="text-align: center" > <span>-</span></el-col>
            <el-col :span="11">
              <el-time-picker
                placeholder="选择时间"
                v-model="formData.startTime"
                style="width: 100%"
                :clearable="false"
                value-format="HH:mm:ss"
                format="HH:mm:ss"
              ></el-time-picker>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="结束时间"  prop="endDate">
          <el-row>
            <el-col :span="11">
              <el-date-picker
                v-model="formData.endDate"
                type="date"
                :clearable="false"
                value-format="yyyy年MM月dd日"
                format="yyyy年MM月dd日"
                placeholder="选择日期">
              </el-date-picker>
            </el-col>
            <el-col :span="2" style="text-align: center" > <span>-</span></el-col>
            <el-col :span="11">
              <el-time-picker
                placeholder="选择时间"
                v-model="formData.endTime"
                style="width: 100%"
                :clearable="false"
                value-format="HH:mm:ss"
                format="HH:mm:ss"
              ></el-time-picker>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">立即授权</el-button>
          <el-button @click="dialogTableVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>


    <el-dialog title="取消地段授权" :visible.sync="cancelDialogTableVisible" width="600px">
      <el-form ref="removeAuthorize" :model="formCancelData" :rules="cancelRules" label-width="80px" >
        <el-form-item label="钥匙" prop="keyId">
          <el-select v-model="formCancelData.keyId" placeholder="请选择活动区域">
            <el-option label="302302" value="302302"></el-option>
            <el-option label="301468" value="301468"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="cancelAuth">取消授权</el-button>
          <el-button @click="cancelDialogTableVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>


    <br />
    <br />

    <!-- 指定开锁列表（不带时间限制） -->
    <el-card class="box-card">
      <el-form ref="form" :model="form" label-width="250px" label-position="top">
        <el-form-item label="开锁地段列表（带时间限制）">
          <div style="display: flex; align-items: center">
            <el-button type="primary" style="margin-right:50px" @click="add">地段授权</el-button>
            <el-input type="textarea" rows="10" resize="none" style="width: 50%;margin-right:10px;" readonly v-model="getSendData"></el-input>
            <el-input type="textarea" placeholder="" rows="10" v-model="getSendReturnData" resize="none"></el-input>
          </div>
          <br />
          <div style="display: flex; align-items: center">
            <el-button type="danger" style="margin-right:50px" @click="remove">取消授权</el-button>
            <el-input type="textarea" rows="5" resize="none" style="width: 50%;margin-right:10px;" readonly v-model="cancelSendData"></el-input>
            <el-input type="textarea" placeholder="" rows="5" v-model="cancelData" resize="none"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="读取开锁授权列表">
          <div style="display: flex; align-items: center">
            <el-button type="primary" style="margin-right:50px" @click="readOpenAuthList">读取</el-button>
            <el-input type="textarea" rows="10" resize="none" style="width: 50%;margin-right:10px;" v-model="openAuth"></el-input>
            <el-input type="textarea" placeholder="" v-model="openAuthList" rows="10" resize="none"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="读取钥匙开锁记录">
          <div style="display: flex; align-items: center">
            <el-button type="primary" style="margin-right:50px" @click="readOpenLockList">读取</el-button>
            <el-input type="textarea" rows="10" resize="none" style="width: 50%;margin-right:10px;" v-model="openLock"></el-input>
            <el-input type="textarea" placeholder="" rows="10" v-model="openLockList" resize="none"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="清除开锁授权列表">
          <div style="display: flex; align-items: center">
            <el-button type="primary" style="margin-right:50px" @click="clearOpenLockList">清除</el-button>
            <el-input type="textarea" rows="10" resize="none" style="width: 50%;margin-right:10px;" v-model="clearLock"></el-input>
            <el-input type="textarea" placeholder="" rows="10" v-model="clearLockList" resize="none"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="读取钥匙编号">
          <div style="display: flex; align-items: center">
            <el-button type="primary" style="margin-right:50px" @click="readKey">读取</el-button>
            <el-input type="textarea" rows="5" resize="none" style="width: 50%;margin-right:10px;" v-model="readKeyParams"></el-input>
            <el-input type="textarea" placeholder="" rows="5" v-model="redkeySn" resize="none"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="配置钥匙初始化">
          <div style="display: flex; align-items: center">
            <el-button type="primary" style="margin-right:50px" @click="initKeyParams">配置</el-button>
            <el-input type="textarea" rows="10" resize="none" style="width: 50%;margin-right:10px;" v-model="initKey"></el-input>
            <el-input type="textarea" placeholder="" rows="10" v-model="initKeyList" resize="none"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="读取钥匙基础信息">
          <div style="display: flex; align-items: center">
            <el-button type="primary" style="margin-right:50px" @click="readKeyMessage">读取</el-button>
            <el-input type="textarea" rows="5" resize="none" style="width: 50%;margin-right:10px;" v-model="keyMsgSn"></el-input>
            <el-input type="textarea" placeholder="" rows="5" v-model="keyMessage" resize="none"></el-input>
          </div>
        </el-form-item>
      </el-form>
    </el-card>
    <br />
    <br />

    <!--    <iframe  src="https://gdal.cn/demo/index.html#/"  width="100%" height="500px" allow="serial"></iframe>-->
  </div>
</template>

<script>
import { ElNotification } from 'element-ui';
import { Message } from 'element-ui';
// import {getHexToStr, getStar, getStrToHex} from './util'
export default {
  data() {
    return {
      receivedMessage: '等待...',
      sendData: '请输入...',
      // sign: 0,
      sendingData: false,
      selectValue1: 1, // 默认值为 0
      selectValue2: 1, // 默认值为 0
      formData: {
        company: 101,
        keyId: '',
        districtId: [],
        startDate: '',
        startTime: '',
        endDate: '',
        endTime: '',
      },
      rules: {
        keyId: [{required: true, message: '请选择钥匙', trigger: 'blur'}],
        districtId: [{required: true, message: '请选择授权区域', trigger: 'blur'}],
        startDate: [{required: true, message: '请选择', trigger: 'blur'}],
        startTime: [{required: true, message: '请选择', trigger: 'blur'}],
        endDate: [{required: true, message: '请选择', trigger: 'blur'}],
        endTime: [{required: true, message: '请选择', trigger: 'blur'}]
      },
      formCancelData: {
        company: 101,
        keyId: '',
      },
      cancelRules: {
        keyId: [{required: true, message: '请选择钥匙', trigger: 'blur'}]
      },
      getSendData: null,
      cancelSendData: null,
      overSendData: {
        OrderVersion: "0001",
        Manufacturer: "0101",
        LockType: "0001",
        KeyProgram: "0001",
        KeyBarcode: "301468",
        TaskTime: new Date().getTime(),
        Array: {
          AuthorizationList: []
        }
      },
      cancelAuthData: {
        OrderVersion: "0001",
        Manufacturer: "0101",
        LockType: "0001",
        KeyProgram: "0003",
        KeyBarcode: "301468",
        TaskTime: new Date().getTime(),
        Array: []
      },
      openAuthList: null ,
      openAuth: JSON.stringify({
        "OrderVersion": "0001",
        "Manufacturer": "0001",
        "LockType": "0001",
        "KeyProgram": "0101",
        "KeyBarcode": "301997",
        "TaskTime": this.formatTimeWithDate(this.formatDateToChinese(new Date()))
      }),
      openLockList: null ,
      openLock: JSON.stringify({
        "OrderVersion": "0001",
        "Manufacturer": "0001",
        "KeyProgram": "0102",
        "KeyBarcode": "301997",
        "TaskTime": this.formatTimeWithDate(this.formatDateToChinese(new Date()))
      }),
      clearLockList: null ,
      clearLock: JSON.stringify({
        "OrderVersion": "0001",
        "Manufactor": "0101",
        "KeyProgram": "0003",
        "KeyBarcode": "301997",
        "TaskTime": this.formatTimeWithDate(this.formatDateToChinese(new Date())),
        "Array": [] // 表示情况所有
      }),
      redkeySn: null,
      readKeyParams: JSON.stringify({
        "OrderVersion": "0001",
        "Manufacturer": "0101",
        "KeyProgram": "0104",
        "TaskTime":this.formatTimeWithDate(this.formatDateToChinese(new Date())),
      }),
      initKey: JSON.stringify({
        "OrderVersion": "0001",
        "Manufacturer": "0001",
        "KeyProgram": "0002",
        "KeyBarcode": "301997",
        "TaskTime": this.formatTimeWithDate(this.formatDateToChinese(new Date())),
        "Array": {
          "KeyBarcode": "301992",
          "Period": "20251212",
          "Password": "123456",
          "KeyHolder": "李四",
          "LockList": [{
            "Manufactor": "6000507",
            "LockType": '0'
          }]
        }
      }),
      initKeyList: null,
      keyMsgSn: JSON.stringify({
        "OrderVersion": "0001",
        "Manufacturer": "0001",
        "KeyProgram": "0103",
        "KeyBarcode": "301997",
        "TaskTime": this.formatTimeWithDate(this.formatDateToChinese(new Date())),
      }),
      keyMessage: null,
      form: {},
      dialogTableVisible:false,
      cancelDialogTableVisible: false,
      // overArrayData: '', // 地段授权的数据
      sendMessage: '',
      cancelData: '',
      setTimeObj: '',
      outTime: false, // 超时时间
      getSendReturnData: '',
      districtList: [
        {value: "100", label: "授权区域测试1_100"},
        {value: "101", label: "授权区域测试1_101"}],
      // sendStatus: false // 连接状态
    };
  },
  mounted() {

    let xxx = localStorage.getItem('loginStatus')
    if (!xxx) {
      this.$message.error('请登录对应账号~')
      this.$router.push({path: '/login'})
    }
    //用于接收扩展坞的信息
    window.addEventListener('serialDataReceived', this.handleSerialDataReceived);


    // 全局串口设备插入事件
    navigator.serial.onconnect = (event) => {
      console.log("检测到有新设备插入：", event.target);
    };

// 全局串口设备拔出事件
    navigator.serial.ondisconnect = (event) => {
      console.log("检测到有新设备拔出：", event.target);
    };

// 也可以对单个的串口设备设置插入与拔出事件
  },
  beforeDestroy() {
    window.removeEventListener('serialDataReceived', this.handleSerialDataReceived);
    if (window.mySdk && window.mySdk.isConnected() === 1) {//销毁前关闭连接中的hid设备
      window.mySdk.closeHid();
    }
  },
  methods: {
    add() {
      this.dialogTableVisible = true
      this.$refs.districtAuthorizeForm && this.$refs.districtAuthorizeForm.resetFields()
      this.formData.startTime = ''
      this.formData.endTime = ''
    },
    remove() {
      this.cancelDialogTableVisible = true
      this.$refs.removeAuthorize && this.$refs.removeAuthorize.resetFields()
    },
    outLogin() {
      this.$confirm('此操作将退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('loginStatus')
        setTimeout(() => {
          this.$router.push({path: '/login'})
        }, 300)
      }).catch(() => {});

    },
    requestPower(){
      this.receivedMessage = "";
      this.packetLength = "";
      window.mySdk.openHid();
      // if(true){//可选通用设备
      //   console.log('wolaole')
      //   window.mySdk.testHid();
      // } else {//使用指定设备
      //   console.log('ds')
      //
      // }
    },
    formatTimeWithDate(inputStr) {
      // 2025年06月03日 11:55:30 转化成20250603T115530
      // 提取时间组件
      const [datePart, timePart] = inputStr.split(' ');
      const year = datePart.split('年')[0];
      const month = datePart.split('年')[1].split('月')[0];
      const day = datePart.split('月')[1].split('日')[0];
      const [hour, minute, second] = timePart.split(':');
      // 拼接成目标格式
      return `${year}${month.padStart(2, '0')}${day.padStart(2, '0')}T${hour.padStart(2, '0')}${minute.padStart(2, '0')}${second.padStart(2, '0')}`;

    },
    formatDateToChinese(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需+1
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`;
    },
    // 读取开锁授权列表
    readOpenAuthList() {
      if (!this.openAuth) {
        this.$message.warning('参数不能为空')
        return false
      }
      this.sendMessage = '读取开锁授权列表'
      this.selectValue2 = 0 // 去读钥匙信息
      this.sendCMDDataPort(JSON.parse(this.openAuth))
    },
    // 读取开锁记录
    readOpenLockList() {
      if (!this.openLock) {
        this.$message.warning('参数不能为空')
        return false
      }
      this.sendMessage = '读取钥匙开锁记录'
      this.selectValue2 = 0 // 去读钥匙信息
      this.sendCMDDataPort(JSON.parse(this.openLock))
    },
    // 清除开锁授权列表
    clearOpenLockList() {
      if (!this.clearLock) {
        this.$message.warning('参数不能为空')
        return false
      }
      this.sendMessage = '清除开锁授权列表'
      this.sendCMDDataPort(JSON.parse(this.clearLock))
    },
    // 读取钥匙编号
    readKey() {
      if (!this.readKeyParams) {
        this.$message.warning('参数不能为空')
        return false
      }
      this.sendMessage = '读取钥匙编号'
      this.selectValue2 = 0
      this.sendCMDDataPort(JSON.parse(this.readKeyParams))
    },
    // 配置钥匙初始化
    initKeyParams() {
      if (!this.initKey) {
        this.$message.warning('参数不能为空')
        return false
      }
      this.sendMessage = '配置钥匙初始化'
      this.sendCMDDataPort(JSON.parse(this.initKey))
    },
    // 读取钥匙基础信息
    readKeyMessage() {
      if (!this.keyMsgSn) {
        this.$message.warning('参数不能为空')
        return false
      }
      this.sendMessage = '读取钥匙基础信息'
      this.sendCMDDataPort(JSON.parse(this.keyMsgSn))
    },
    onSubmit() { // 地段授权
      this.$refs.districtAuthorizeForm.validate(valid => {
        if (valid) {
          let start = this.formData.startDate.match(/\d+/g), end = this.formData.endDate.match(/\d+/g);
          if (parseInt(end.join('')) < parseInt(start.join(''))) {
            this.$message({
              type: 'warning',
              message: '开始时间不能小于结束时间'
            })
            return false
          }
          // 数据拼接
          this.overSendData.KeyBarcode = this.formData.keyId
          this.overSendData.TaskTime = this.formatTimeWithDate(this.formatDateToChinese(new Date()))
          this.overSendData.Array.AuthorizationList = []
          this.overSendData.Array.AuthorizationList.push({
            startTime: this.formatTimeWithDate(`${this.formData.startDate} ${this.formData.startTime}`),
            endTime: this.formatTimeWithDate(`${this.formData.endDate} ${this.formData.endTime}`),
            LockApplyList: []
          })
          let objs = []
          this.formData.districtId.forEach((ele) => {
            this.districtList.forEach((el) => {
              if (ele === el.value) {
                objs.push({
                  LockBarcode: '',
                  Section: ele,
                  Lockname: el.label
                })
                this.overSendData.Array.AuthorizationList[0].LockApplyList = objs
              }
            })
          })
          this.sendMessage = '授权'
          this.getSendData = JSON.stringify(this.overSendData)
          this.sendCMDDataPort(this.overSendData)
        }
      })
    },
    //  取消地段授权
    cancelAuth () {
      this.$refs.removeAuthorize.validate(valid => {
        if (valid) {
          //   字节数据格式如下
          // this.cancelAuthData.Array 如果内容为空表示清空开锁授权列表,如下表格
          this.cancelAuthData.KeyBarcode = this.formCancelData.keyId
          this.cancelAuthData.TaskTime = this.formatTimeWithDate(this.formatDateToChinese(new Date()))
          this.sendMessage = '取消授权'
          this.cancelSendData = JSON.stringify(this.cancelAuthData)
          this.sendCMDDataPort(this.cancelAuthData)
        }
      })
    },
    sendCMDDataPort(sendData) {
       // console.log(sendData, '============sendData')
      this.receivedMessage = "";
      this.packetLength = "";
      this.sendingData = true;
      clearTimeout(this.setTimeObj);
      //发送时需将数据转换成json
      try {
        window.mySdk.hidSend(this.selectValue1,this.selectValue2, sendData) .then(result => {
          // if (!this.sendStatus) {
          //   this.$message({
          //     message: '请重连设备~',
          //     type: 'warning'
          //   });
          //   this.dialogTableVisible = false
          //   this.cancelDialogTableVisible = false
          //   return false
          // }
          this.sendingData = false; // 数据发送完毕，隐藏加载指示器
          this.receivedMessage = "数据发送成功";
          this.$message({
            message: this.receivedMessage,
            type: 'success'
          });
          setTimeout(() => {
            Message.closeAll(); // 关闭所有消息
            if (!this.outTime) {
              this.$message({
                message: '正在等待扩展坞回复~',
                type: 'info',
                duration: 0
              });
            }
          }, 800)
          this.outTime = false // 设置当前默认无数据回复
          this.setTimeObj = setTimeout(() => {
            Message.closeAll(); // 关闭所有消息
            if (!this.outTime) {
              this.$message({
                message: '扩展坞回复超时~',
                type: 'error'
              });
            }
            console.log(this.outTime, '===-=-=-=-')
          }, 42000)
          this.dialogTableVisible = false
          this.cancelDialogTableVisible = false
        })
      } catch (e) {
        this.receivedMessage = '您输入的json格式有误，转换失败';
      }
      this.sendingData = false;
    },
    handleSerialDataReceived(event) {
      //返回标志和数据
      //sign = 1 表示扩展坞回复信息成功 message就是钥匙回复的数据
      //sign = -1 表示读取循环出错啦
      //sign = -2 表示无法读取到串口了 请重新打开串口
      Message.closeAll(); // 关闭所有消息
      // this.getSendReturnData = ''
      if (event.detail.sign === 1) {
        let xxx = JSON.parse(event.detail.message);
        this.sendMessage === '授权' ? this.getSendReturnData = event.detail.message : ''
        this.sendMessage === '取消授权' ? this.cancelData = event.detail.message : ''
        this.sendMessage === '读取开锁授权列表' ? this.openAuthList = event.detail.message : ''
        this.sendMessage === '读取钥匙开锁记录' ? this.openLockList = event.detail.message : ''
        this.sendMessage === '清除开锁授权列表' ? this.clearLockList = event.detail.message : ''
        this.sendMessage === '读取钥匙编号' ? this.redkeySn = event.detail.message : ''
        this.sendMessage === '配置钥匙初始化' ? this.initKeyList = event.detail.message : ''
        this.sendMessage === '读取钥匙基础信息' ? this.keyMessage = event.detail.message : ''
        console.log(this.sendMessage, this.keyMessage, event.detail.message,'-========')
        if (xxx.return === '01') { // 编程成功
          this.$message({
            message: this.sendMessage + '成功',
            type: 'success'
          });
          this.dialogTableVisible = false
          // this.sendStatus = true
        } else { // 编程失败
          this.$message({
            message: this.sendMessage + '失败',
            type: 'error'
          });
        }
        // this.sendStatus = true
      } else if (event.detail.sign === 2) {
        this.$message({
          message: event.detail.message,
          type: 'success'
        });
        // this.sendStatus = true
      } else {
        this.$message({
          message: event.detail.message,
          type: 'error'
        });
        // this.sendStatus = false
      }
      this.outTime = true
      clearTimeout(this.setTimeObj)
      console.log(event,this.outTime, '串口响应信息')
    }
  },
};
</script>

<style scoped>
.serial-port-container {
  padding: 20px;
}

.received-message {
  margin-bottom: 20px;
  font-size: 16px;
  color: #333;
}
.default-button {
  background-color: #ffffff;
  color: #409EFF;
  border: 1px solid #409EFF;
}

.blue-button {
  background-color: #409EFF;
  color: #ffffff;
}
.dock_demo {
  padding:20px 50px;
//width:600px;
//margin:auto;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue